function submitExportAllForm() {
  const form = document.querySelector<HTMLFormElement>('#form-export-all')
  if (form) {
    form.submit()
  }
}

function initExportModal() {
  const exportAllConfirmBtn = document.querySelector<HTMLButtonElement>(
    '#export-all-confirm',
  )
  if (exportAllConfirmBtn) {
    exportAllConfirmBtn.onclick = () => {
      submitExportAllForm()
    }
  }
}

export { initExportModal }
